"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9276],{

/***/ 9276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ui_container_AboutUs; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/gsap/index.js + 2 modules
var gsap = __webpack_require__(4682);
// EXTERNAL MODULE: ../../node_modules/gsap/dist/ScrollTrigger.js
var ScrollTrigger = __webpack_require__(5480);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/breakpoints.js
var size = {
  mobile: '767px'
};
var device = {
  mobile: "(max-width: ".concat(size.mobile, ")")
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/HeroVideo/HeroVideo.styles.ts


var HeroVideoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "HeroVideostyles__HeroVideoContainer",
  componentId: "sc-1uzv6jl-0"
})(["width:540px;height:480px;border-radius:24px;overflow:hidden;margin-left:90px;flex-shrink:0;> img{width:100%;height:100%;object-fit:cover;}> video{width:100%;height:100%;object-fit:cover;border-radius:24px;}@media ", "{width:100%;height:300px;margin-left:0;border-radius:12px;> video{border-radius:12px;}}"], device.mobile);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/HeroVideo/HeroVideo.tsx



var HeroVideo = function HeroVideo(_ref) {
  var src = _ref.src,
      poster = _ref.poster;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(HeroVideoContainer, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("video", {
      preload: "",
      controls: false,
      src: src,
      muted: true,
      autoPlay: true,
      loop: true,
      playsInline: true,
      poster: poster
    })
  });
};

/* harmony default export */ var HeroVideo_HeroVideo = (HeroVideo);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/ScrollButton/ScrollButton.styles.ts


var ScrollBtn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ScrollButtonstyles__ScrollBtn",
  componentId: "sc-6usmfl-0"
})(["display:inline-flex;width:24px;height:44px;border:2px #000 solid;border-radius:30px;position:relative;margin-top:60px;justify-content:center;@media ", "{display:none;}"], device.mobile);
var ScrollDot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ScrollButtonstyles__ScrollDot",
  componentId: "sc-6usmfl-1"
})(["width:6px;height:6px;border-radius:100%;background:#000;animation:bounce 1.5s;animation-iteration-count:infinite;@keyframes bounce{from{transform:translate3d(0,6px,0);opacity:1;}to{transform:translate3d(0,26px,0);opacity:0;}}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/ScrollButton/ScrollButton.tsx



var ScrollButton = function ScrollButton(_ref) {
  var buttonRef = _ref.buttonRef;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ScrollBtn, {
    ref: buttonRef,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ScrollDot, {})
  });
};

/* harmony default export */ var ScrollButton_ScrollButton = (ScrollButton);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/HeroBanner/HeroBanner.styles.ts


var HeroBnrContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "HeroBannerstyles__HeroBnrContainer",
  componentId: "sc-1un08p9-0"
})(["display:flex;height:100vh;background-size:cover;position:relative;@media ", "{flex-direction:column;height:70vh;}"], device.mobile);
var HeroBnrContainerInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "HeroBannerstyles__HeroBnrContainerInner",
  componentId: "sc-1un08p9-1"
})(["width:100%;height:100%;position:absolute;left:0;top:0;display:flex;align-items:center;@media ", "{align-items:flex-start;flex-direction:column;}"], device.mobile);
var HeroBnrContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "HeroBannerstyles__HeroBnrContent",
  componentId: "sc-1un08p9-2"
})(["width:1200px;display:flex;margin:0 auto;@media ", "{width:100%;padding:70px 16px 16px 16px;flex-direction:column;}"], device.mobile);
var HeroBnrDtl = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "HeroBannerstyles__HeroBnrDtl",
  componentId: "sc-1un08p9-3"
})(["width:566px;display:flex;flex-direction:column;justify-content:center;h1{font-size:56px;line-height:65px;color:#000;font-weight:400;font-family:\"Raleway\";@media ", "{font-size:32px;line-height:38px;margin-bottom:20px;}}@media ", "{width:100%;}"], device.mobile, device.mobile);
var HeroBnrVideo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "HeroBannerstyles__HeroBnrVideo",
  componentId: "sc-1un08p9-4"
})(["flex:1;display:flex;align-items:center;@media ", "{position:relative;z-index:3;}"], device.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/HeroBanner/HeroBanner.tsx








gsap/* gsap.registerPlugin */.p8.registerPlugin(ScrollTrigger.ScrollTrigger);

var HeroBanner = function HeroBanner(_ref) {
  var title = _ref.title,
      src = _ref.src,
      alt = _ref.alt,
      heroVideo = _ref.heroVideo;
  var mainRef = (0,react.useRef)();
  var headingRef = (0,react.useRef)();
  var videoRef = (0,react.useRef)();
  var bgImageRef = (0,react.useRef)();
  var buttonRef = (0,react.useRef)();

  var _useState = (0,react.useState)(),
      windowHeight = _useState[0],
      setWindowHeight = _useState[1];

  (0,react.useEffect)(function () {
    setWindowHeight(window.innerHeight);
  }, []);
  (0,react.useEffect)(function () {
    var video = videoRef.current;
    var bgImage = bgImageRef.current; // if(windowHeight == null){
    //     return;
    // }

    ScrollTrigger.ScrollTrigger.matchMedia({
      "(min-width: 769px)": function minWidth769px() {
        gsap/* gsap.to */.p8.to(headingRef.current, {
          scrollTrigger: {
            trigger: mainRef.current,
            start: "50% 40%",
            end: "50% 20%",
            pinSpacing: false,
            toggleActions: "restart resume none reverse",
            scrub: true
          },
          opacity: 0,
          duration: 2
        });
        gsap/* gsap.to */.p8.to(buttonRef.current, {
          scrollTrigger: {
            trigger: mainRef.current,
            start: "50% 40%",
            end: "50% 30%",
            pinSpacing: false,
            toggleActions: "restart resume none reverse",
            scrub: true
          },
          opacity: 0,
          duration: 2
        });
        gsap/* gsap.to */.p8.to(video, {
          scrollTrigger: {
            trigger: mainRef.current,
            start: "top top",
            end: "+=".concat(windowHeight * 70 / 100 * 3),
            pin: video,
            pinSpacing: false
          }
        });
        gsap/* gsap.to */.p8.to(bgImage, {
          scrollTrigger: {
            trigger: mainRef.current,
            start: "top top",
            end: "+=".concat(windowHeight * 70 / 100 * 3),
            pin: bgImage,
            pinSpacing: false
          }
        });
      },
      "(max-width: 767px)": function maxWidth767px() {
        gsap/* gsap.to */.p8.to(video, {
          scrollTrigger: {
            trigger: mainRef.current,
            start: "top -18%",
            end: "+=".concat(windowHeight * 25 / 100 * 3),
            pin: video,
            pinSpacing: false
          }
        });
        gsap/* gsap.to */.p8.to(bgImage, {
          scrollTrigger: {
            trigger: mainRef.current,
            start: "top top",
            end: "+=".concat(windowHeight * 25 / 100 * 3),
            pin: bgImage,
            pinSpacing: false
          }
        });
      }
    });
  }, [windowHeight]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(HeroBnrContainer, {
    ref: mainRef,
    id: "heroBanner",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeroBnrContainerInner, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(HeroBnrContent, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(HeroBnrDtl, {
          id: "heroBnrDtl",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
            ref: headingRef,
            children: title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ScrollButton_ScrollButton, {
            buttonRef: buttonRef
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(HeroBnrVideo, {
          ref: videoRef,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeroVideo_HeroVideo, {
            src: heroVideo === null || heroVideo === void 0 ? void 0 : heroVideo.src,
            poster: heroVideo === null || heroVideo === void 0 ? void 0 : heroVideo.poster
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: src,
      alt: alt,
      ref: bgImageRef
    })]
  });
};

/* harmony default export */ var HeroBanner_HeroBanner = (HeroBanner);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/OurJourneyCard/OurJourneyCard.styles.ts


var JourneyCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OurJourneyCardstyles__JourneyCard",
  componentId: "sc-1y36tc0-0"
})(["width:", ";background-color:", ";padding:20px;border-radius:16px;flex-shrink:0;align-self:flex-start;display:flex;:nth-child(1){margin-top:150px;}:nth-child(2){margin-top:100px;}:nth-child(3){margin-top:50px;}@media ", "{width:180px;padding:8px 12px;border-radius:12px;align-self:flex-end;:nth-child(1){margin-top:16px;margin-right:150px;}:nth-child(2){margin-top:16px;margin-right:100px;}:nth-child(3){margin-top:16px;margin-right:50px;}}"], function (p) {
  return p.width ? p.width : "284px";
}, function (p) {
  return p.bgColor ? p.bgColor : "#fff";
}, device.mobile);
var JourneyCardIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "OurJourneyCardstyles__JourneyCardIcon",
  componentId: "sc-1y36tc0-1"
})(["flex-shrink:0;margin-right:8px;padding-top:7px;@media ", "{padding-top:2px;}"], device.mobile);
var JourneyCardDtl = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OurJourneyCardstyles__JourneyCardDtl",
  componentId: "sc-1y36tc0-2"
})(["flex:1;"]);
var CardHeading = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
  displayName: "OurJourneyCardstyles__CardHeading",
  componentId: "sc-1y36tc0-3"
})(["font-family:\"Open Sans\";font-size:24px;line-height:32px;color:#000;font-weight:600;display:flex;align-items:center;@media ", "{font-size:14px;line-height:19px;}"], device.mobile);
var CardDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "OurJourneyCardstyles__CardDescription",
  componentId: "sc-1y36tc0-4"
})(["font-family:\"Open Sans\";font-size:14px;line-height:20px;color:#000;margin:16px 0;opacity:0.8;@media ", "{font-size:12px;line-height:16px;margin:3px 0;}"], device.mobile);
var OverallText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "OurJourneyCardstyles__OverallText",
  componentId: "sc-1y36tc0-5"
})(["font-family:\"Open Sans\";font-size:14px;line-height:20px;color:#000;margin-top:16px;@media ", "{font-size:12px;line-height:16px;margin-top:5px;}"], device.mobile);
var Customers = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "OurJourneyCardstyles__Customers",
  componentId: "sc-1y36tc0-6"
})(["font-family:\"Open Sans\";font-size:16px;line-height:22px;color:#000;font-weight:600;span{color:#2b825e;}@media ", "{font-size:12px;line-height:16px;}"], device.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/OurJourneyCard/OurJourneyCard.tsx




var OurJourneyCard = function OurJourneyCard(_ref) {
  var data = _ref.data,
      cardRef = _ref.cardRef,
      pinIconSrc = _ref.pinIconSrc;
  var year = data.year,
      description = data.description,
      overall = data.overall,
      pinIcon = data.pinIcon,
      bgColor = data.bgColor,
      footerText = data.footerText;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(JourneyCard, {
    bgColor: bgColor,
    ref: cardRef,
    className: "journeyCard",
    children: [pinIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(JourneyCardIcon, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: pinIconSrc
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(JourneyCardDtl, {
      children: [year && /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeading, {
        children: year
      }), description && /*#__PURE__*/(0,jsx_runtime.jsx)(CardDescription, {
        children: description
      }), overall && /*#__PURE__*/(0,jsx_runtime.jsx)(OverallText, {
        children: "Overall"
      }), footerText && /*#__PURE__*/(0,jsx_runtime.jsx)(Customers, {
        dangerouslySetInnerHTML: {
          __html: footerText
        }
      })]
    })]
  });
};

/* harmony default export */ var OurJourneyCard_OurJourneyCard = (OurJourneyCard);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/OurJourney/OurJourney.styles.ts


var OurJourneySection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "OurJourneystyles__OurJourneySection",
  componentId: "sc-15c8wcf-0"
})(["background:#000 url(\"https://tripmoneycmsimgak.mmtcdn.com/img/grid_dc77da6617.svg\") 0 0 repeat;height:100vh;position:relative;padding:100px 0;overflow:hidden;margin:0 auto;@media ", "{padding:40px 0;height:auto;}"], device.mobile);
var OurJourneyInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OurJourneystyles__OurJourneyInner",
  componentId: "sc-15c8wcf-1"
})(["width:100%;height:100%;position:absolute;left:0;top:0;padding:100px 0;z-index:2;@media ", "{padding:40px 0;position:unset;}"], device.mobile);
var OurJourneyArrow = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "OurJourneystyles__OurJourneyArrow",
  componentId: "sc-15c8wcf-2"
})(["width:75%;position:absolute;left:0;top:100px;z-index:1;"]);
var OurJourneyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OurJourneystyles__OurJourneyWrapper",
  componentId: "sc-15c8wcf-3"
})(["width:1200px;margin:0 auto;> h2{font-family:\"Raleway\";font-size:48px;line-height:64px;color:#fff;font-weight:400;@media ", "{font-size:32px;line-height:36px;}}> h3{max-width:810px;font-family:\"Open Sans\";font-size:22px;line-height:30px;font-weight:400;color:#afafaf;margin-top:16px;@media ", "{max-width:100%;font-size:16px;line-height:22px;}}@media ", "{width:100%;padding:0 16px;}"], device.mobile, device.mobile, device.mobile);
var OurJourneyCardContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OurJourneystyles__OurJourneyCardContainer",
  componentId: "sc-15c8wcf-4"
})(["display:flex;justify-content:space-between;margin-top:20px;@media ", "{flex-direction:column-reverse;align-items:flex-start;}"], device.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/OurJourney/OurJourney.tsx







gsap/* gsap.registerPlugin */.p8.registerPlugin(ScrollTrigger.ScrollTrigger);

var OurJourney = function OurJourney(_ref) {
  var heading = _ref.heading,
      subHeading = _ref.subHeading,
      journeyData = _ref.journeyData,
      arrowSrc = _ref.arrowSrc,
      arrowAlt = _ref.arrowAlt,
      pinIconSrc = _ref.pinIconSrc;
  var mainRef = (0,react.useRef)();
  var headingRef = (0,react.useRef)();
  var subHeadingRef = (0,react.useRef)();
  var cardRef1 = (0,react.useRef)();
  var cardRef2 = (0,react.useRef)();
  var cardRef3 = (0,react.useRef)();
  var cardRef4 = (0,react.useRef)();
  var arr = [cardRef1, cardRef2, cardRef3, cardRef4];
  (0,react.useEffect)(function () {
    var cards = [cardRef4.current, cardRef3.current, cardRef2.current, cardRef1.current];
    gsap/* gsap.from */.p8.from(headingRef.current, {
      scrollTrigger: {
        trigger: mainRef.current,
        start: "top 70%",
        toggleActions: "restart resume none reverse"
      },
      y: 100,
      opacity: 0,
      ease: "ease-in-out",
      duration: 1
    });
    gsap/* gsap.from */.p8.from(subHeadingRef.current, {
      scrollTrigger: {
        trigger: mainRef.current,
        start: "top 70%",
        toggleActions: "restart resume none reverse"
      },
      y: 100,
      opacity: 0,
      ease: "ease-in-out",
      duration: 1
    }); // background grid animation

    gsap/* gsap.from */.p8.from(mainRef.current, {
      backgroundPosition: function backgroundPosition() {
        return "0% -".concat(mainRef.current.getBoundingClientRect().top / 1.5, "px");
      },
      ease: "none",
      scrollTrigger: {
        trigger: mainRef.current,
        //start: () => i ? "top bottom" : "top top",
        //end: "bottom top",
        scrub: true,
        invalidateOnRefresh: true // to make it responsive

      }
    });
    ScrollTrigger.ScrollTrigger.matchMedia({
      "(min-width: 769px)": function minWidth769px() {
        //journey section small to large animation
        gsap/* gsap.from */.p8.from(mainRef.current, {
          scrollTrigger: {
            trigger: mainRef.current,
            start: "top 90%",
            end: "top 50%",
            toggleActions: "restart resume none reverse",
            scrub: true
          },
          width: 1200,
          borderRadius: "40px",
          ease: "ease-in-out",
          duration: 1
        });
        gsap/* gsap.from */.p8.from(cards, {
          scrollTrigger: {
            trigger: mainRef.current,
            start: "top 40%",
            toggleActions: "restart resume none reverse",
            scrub: true,
            end: "bottom bottom",
            onLeave: function onLeave() {
              gsap/* gsap.to */.p8.to(cards, {
                scrollTrigger: {
                  trigger: mainRef.current,
                  start: "top top",
                  end: "bottom top",
                  toggleActions: "restart resume none reverse",
                  scrub: true
                },
                y: -300,
                opacity: 0,
                stagger: 0.3,
                ease: "ease-in-out",
                duration: 3
              });
            }
          },
          y: 300,
          opacity: 0,
          stagger: 0.5,
          ease: "ease-in-out",
          duration: 4
        });
      },
      "(max-width: 767px)": function maxWidth767px() {
        gsap/* gsap.from */.p8.from(cards, {
          scrollTrigger: {
            trigger: mainRef.current,
            start: "top 40%",
            toggleActions: "restart resume none reverse",
            scrub: true,
            end: "top 20%"
          },
          y: 300,
          opacity: 0,
          stagger: 0.5,
          ease: "ease-in-out",
          duration: 4
        });
      }
    });
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OurJourneySection, {
    ref: mainRef,
    id: "ourJourney",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OurJourneyInner, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(OurJourneyWrapper, {
        children: [heading && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          id: "heading",
          ref: headingRef,
          children: heading
        }), subHeading && /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
          id: "subHeading",
          ref: subHeadingRef,
          children: subHeading
        }), journeyData && journeyData.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(OurJourneyCardContainer, {
          children: journeyData.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(OurJourneyCard_OurJourneyCard, {
              cardRef: arr[index],
              data: item,
              pinIconSrc: pinIconSrc
            }, item.id);
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OurJourneyArrow, {
      src: arrowSrc,
      alt: arrowAlt
    })]
  });
};

/* harmony default export */ var OurJourney_OurJourney = (OurJourney);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/OurTeam/OurTeam.styles.ts


var OurTeamSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "OurTeamstyles__OurTeamSection",
  componentId: "sc-15uxicc-0"
})(["padding:120px 0;background:#fff url(\"https://tripmoneycmsimgak.mmtcdn.com/img/team_bg_4ae2dbf3f2.svg\") top right no-repeat;margin-top:16px;@media ", "{padding:40px 16px;background-size:cover;}"], device.mobile);
var OurTeamWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OurTeamstyles__OurTeamWrapper",
  componentId: "sc-15uxicc-1"
})(["width:1200px;margin:0 auto;@media ", "{width:100%;}"], device.mobile);
var OurTeamContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OurTeamstyles__OurTeamContent",
  componentId: "sc-15uxicc-2"
})(["width:720px;h2{font-family:\"Raleway\";font-size:48px;line-height:64px;color:#000;font-weight:400;margin-bottom:24px;}p{font-family:\"Open Sans\";font-size:22px;line-height:30px;color:#4a4a4a;}h3{font-family:\"Raleway\";font-size:32px;line-height:40px;color:#000;font-weight:400;margin-top:40px;margin-bottom:12px;}@media ", "{width:100%;h2{font-size:32px;line-height:34px;}p{font-size:16px;line-height:22px;}h3{font-size:24px;line-height:28px;}}"], device.mobile);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/LandingButton/LandingButton.tsx + 1 modules
var LandingButton = __webpack_require__(1893);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/OurTeam/OurTeam.tsx





var OurTeam = function OurTeam(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      joinUsInfo = _ref.joinUsInfo,
      opportunities = _ref.opportunities;

  var handleExploreOpportunity = function handleExploreOpportunity() {};

  return /*#__PURE__*/(0,jsx_runtime.jsx)(OurTeamSection, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(OurTeamWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(OurTeamContent, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: subTitle
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
          children: joinUsInfo === null || joinUsInfo === void 0 ? void 0 : joinUsInfo.title
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          children: [joinUsInfo === null || joinUsInfo === void 0 ? void 0 : joinUsInfo.subTitle, /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: joinUsInfo === null || joinUsInfo === void 0 ? void 0 : joinUsInfo.href,
            children: joinUsInfo === null || joinUsInfo === void 0 ? void 0 : joinUsInfo.mail
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: opportunities === null || opportunities === void 0 ? void 0 : opportunities.href,
          target: "_blank",
          rel: "noopener noreferrer",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton/* default */.Z, {
            customTitle: opportunities === null || opportunities === void 0 ? void 0 : opportunities.title,
            customWidth: "300px",
            margin: "40px 0 0 0",
            handleClick: handleExploreOpportunity
          })
        })]
      })
    })
  });
};

/* harmony default export */ var OurTeam_OurTeam = (OurTeam);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/SpotlightCard/SpotlightCard.styles.ts


var SpotlightCardHolder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SpotlightCardstyles__SpotlightCardHolder",
  componentId: "sc-1la85un-0"
})(["width:560px;height:100%;padding:50px 60px;box-shadow:0 0 10px rgba(158,158,158,0.14);border-radius:12px;flex-shrink:0;background-color:#fff;position:relative;overflow:hidden;&::after{content:\"\";position:absolute;width:625px;height:336px;left:352px;top:0px;background:linear-gradient( 295.34deg,#d9d9d9 -6.27%,rgba(217,217,217,0) 73.4% );transform:rotate(45deg);}@media ", "{width:100%;padding:20px;height:100%;&::after{left:180px;}}"], device.mobile);
var SpotlightMedia = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "SpotlightCardstyles__SpotlightMedia",
  componentId: "sc-1la85un-1"
})(["font-family:\"Open Sans\";font-size:16px;line-height:22px;font-weight:600;text-transform:uppercase;@media ", "{font-size:14px;line-height:19px;}"], device.mobile);
var SpotlightTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
  displayName: "SpotlightCardstyles__SpotlightTitle",
  componentId: "sc-1la85un-2"
})(["font-family:\"Raleway\";font-size:32px;line-height:38px;font-weight:500;color:#000;margin:20px 0;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;a{color:#000;}@media ", "{font-size:24px;line-height:28px;margin:18px 0 24px 0;}"], device.mobile);
var SpotlightFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SpotlightCardstyles__SpotlightFooter",
  componentId: "sc-1la85un-3"
})(["display:flex;align-items:center;justify-content:space-between;> p{font-family:\"Open Sans\";font-size:16px;line-height:22px;color:#9b9b9b;}@media ", "{> p{font-size:14px;line-height:19px;}}"], device.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/SpotlightCard/SpotlightCard.tsx





var SpotlightCard = function SpotlightCard(_ref) {
  var item = _ref.item,
      footerArrow = _ref.footerArrow;
  var mediaName = item.mediaName,
      heading = item.heading,
      date = item.date,
      link = item.link;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SpotlightCardHolder, {
    children: [mediaName && /*#__PURE__*/(0,jsx_runtime.jsx)(SpotlightMedia, {
      href: link,
      target: "_blank",
      children: mediaName
    }), heading && /*#__PURE__*/(0,jsx_runtime.jsx)(SpotlightTitle, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: link,
        target: "_blank",
        rel: "noopener noreferrer",
        children: heading
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SpotlightFooter, {
      children: [date && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: date
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: link,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: footerArrow,
          alt: ""
        })
      })]
    })]
  });
};

/* harmony default export */ var SpotlightCard_SpotlightCard = (SpotlightCard);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/SpotlightSlider/SpotlightSlider.styles.ts


var SliderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SpotlightSliderstyles__SliderWrapper",
  componentId: "sc-8lu19q-0"
})(["overflow:hidden;max-width:1200px;padding:10px 0 10px 10px;position:relative;&::after{width:10px;height:100%;content:\"\";background-color:#fff;position:absolute;top:0;right:0;}@media ", "{max-width:100%;padding:0;&::after{display:none;}}"], device.mobile);
var SpotlightCardItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SpotlightSliderstyles__SpotlightCardItem",
  componentId: "sc-8lu19q-1"
})(["width:50%;flex-shrink:0;@media ", "{width:100%;padding:6px;}"], device.mobile);
var SliderHolder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SpotlightSliderstyles__SliderHolder",
  componentId: "sc-8lu19q-2"
})(["transition:ease 1000ms;display:flex;"]);
var SlideDots = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SpotlightSliderstyles__SlideDots",
  componentId: "sc-8lu19q-3"
})(["text-align:center;margin-top:35px;.slideshowDot{background:#3f3d56;opacity:0.2;width:12px;height:12px;border-radius:100%;display:inline-block;margin-right:16px;cursor:pointer;transition:all 0.3s linear;}.slideshowDot.active{width:32px;height:12px;background:#000000 !important;opacity:1;border-radius:6px;}@media ", "{margin-top:20px;.slideshowDot{width:8px;height:8px;margin-right:8px;}.slideshowDot.active{width:20px;height:8px;}}"], device.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/SpotlightSlider/SpotlightSlider.tsx






var SpotlightSlider = function SpotlightSlider(_ref) {
  var data = _ref.data,
      footerArrow = _ref.footerArrow;

  var _useState = (0,react.useState)(0),
      currentIndex = _useState[0],
      setCurrentIndex = _useState[1];

  var _useState2 = (0,react.useState)(data.length),
      length = _useState2[0],
      setLength = _useState2[1];

  var _useState3 = (0,react.useState)(),
      deviceWidth = _useState3[0],
      setDeviceWidth = _useState3[1];

  var _useState4 = (0,react.useState)(null),
      touchPosition = _useState4[0],
      setTouchPosition = _useState4[1];

  (0,react.useEffect)(function () {
    setDeviceWidth(window.innerWidth);
  }, []);
  (0,react.useEffect)(function () {
    setLength(data.length);
  }, [data]);

  var next = function next() {
    if (currentIndex < length - 1) {
      setCurrentIndex(function (prevState) {
        return prevState + 1;
      });
    }
  };

  var prev = function prev() {
    if (currentIndex > 0) {
      setCurrentIndex(function (prevState) {
        return prevState - 1;
      });
    }
  };

  var handleTouchStart = function handleTouchStart(e) {
    var touchDown = e.touches[0].clientX;
    setTouchPosition(touchDown);
  };

  var handleTouchMove = function handleTouchMove(e) {
    var touchDown = touchPosition;

    if (touchDown === null) {
      return;
    }

    var currentTouch = e.touches[0].clientX;
    var diff = touchDown - currentTouch;

    if (diff > 5) {
      next();
    }

    if (diff < -5) {
      prev();
    }

    setTouchPosition(null);
  };

  var timeoutRef = react.useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  react.useEffect(function () {
    resetTimeout();
    timeoutRef.current = setTimeout(function () {
      return setCurrentIndex(function (prevIndex) {
        return prevIndex === data.length - 1 ? 0 : prevIndex + 1;
      });
    }, 2500);
    return function () {
      resetTimeout();
    };
  }, [currentIndex]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SliderWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SliderHolder, {
      onTouchStart: handleTouchStart,
      onTouchMove: handleTouchMove,
      style: {
        transform: "translateX(-".concat(currentIndex * (deviceWidth <= 767 ? 100 : 50), "%)")
      },
      children: data && data.length > 0 && data.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(SpotlightCardItem, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SpotlightCard_SpotlightCard, {
            footerArrow: footerArrow,
            item: item
          })
        }, item.id);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SlideDots, {
      className: "slideshowDots",
      children: data.map(function (_, idx) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "slideshowDot".concat(currentIndex === idx ? " active" : ""),
          onClick: function onClick() {
            setCurrentIndex(idx);
          }
        }, idx);
      })
    })]
  });
};

/* harmony default export */ var SpotlightSlider_SpotlightSlider = (SpotlightSlider);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/Spotlight/Spotlight.styles.ts


var SpotlightSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "Spotlightstyles__SpotlightSection",
  componentId: "crgk9l-0"
})(["padding:120px 0;background-color:#fff;@media ", "{padding:40px 16px;}"], device.mobile);
var SpotlightContent = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "Spotlightstyles__SpotlightContent",
  componentId: "crgk9l-1"
})(["width:1200px;margin:0 auto;> h2{font-family:\"Raleway\";font-size:48px;line-height:64px;color:#000;font-weight:400;}> h3{font-family:\"Open Sans\";font-size:22px;line-height:30px;color:#4a4a4a;font-weight:400;margin-top:8px;}@media ", "{width:100%;> h2{font-size:32px;line-height:34px;}> h3{font-size:16px;line-height:22px;margin-top:12px;}}"], device.mobile);
var SliderCont = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Spotlightstyles__SliderCont",
  componentId: "crgk9l-2"
})(["margin-top:35px;@media ", "{margin-top:24px;}"], device.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/Spotlight/Spotlight.tsx






var Spotlight = function Spotlight(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      spotLightNews = _ref.spotLightNews,
      footerArrow = _ref.footerArrow;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SpotlightSection, {
    id: "spotLight",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SpotlightContent, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: subTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SliderCont, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SpotlightSlider_SpotlightSlider, {
          data: spotLightNews,
          footerArrow: footerArrow
        })
      })]
    })
  });
};

/* harmony default export */ var Spotlight_Spotlight = (Spotlight);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/index.styles.ts

var AboutPageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyles__AboutPageWrapper",
  componentId: "c0kvl6-0"
})(["background-color:#f5f5f5;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/HeroContent/HeroContent.styles.ts


var HeroContentSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "HeroContentstyles__HeroContentSection",
  componentId: "kerqa9-0"
})(["height:70vh;@media ", "{height:auto;}"], device.mobile);
var HeroContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "HeroContentstyles__HeroContentWrapper",
  componentId: "kerqa9-1"
})(["display:flex;width:1200px;margin:0 auto;h2{width:566px;font-size:48px;line-height:56px;color:#000;font-weight:400;font-family:\"Raleway\";span{color:#38a97a;}@media ", "{width:100%;font-size:24px;line-height:28px;}}@media ", "{width:100%;padding:70px 16px;}"], device.mobile, device.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/HeroContent/HeroContent.tsx



var HeroContent = function HeroContent(_ref) {
  var content = _ref.content,
      contentRef = _ref.contentRef;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(HeroContentSection, {
    ref: contentRef,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeroContentWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        dangerouslySetInnerHTML: {
          __html: content
        }
      })
    })
  });
};

/* harmony default export */ var HeroContent_HeroContent = (HeroContent);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/AboutUs/index.tsx











gsap/* gsap.registerPlugin */.p8.registerPlugin(ScrollTrigger.ScrollTrigger);

var AboutUs = function AboutUs(_ref) {
  var heroContent = _ref.heroContent,
      heroBanner = _ref.heroBanner,
      ourJourney = _ref.ourJourney,
      spotLight = _ref.spotLight,
      ourTeam = _ref.ourTeam;
  var contentRef1 = (0,react.useRef)();
  var contentRef2 = (0,react.useRef)();
  var contentRef3 = (0,react.useRef)();
  (0,react.useEffect)(function () {
    ScrollTrigger.ScrollTrigger.matchMedia({
      "(min-width: 769px)": function minWidth769px() {
        gsap/* gsap.from */.p8.from(contentRef1.current, {
          scrollTrigger: {
            trigger: contentRef1.current,
            start: "top 80%",
            end: "center 50%",
            pinSpacing: false,
            toggleActions: "restart resume none reverse",
            scrub: true,
            onLeave: function onLeave() {
              gsap/* gsap.to */.p8.to(contentRef1.current, {
                scrollTrigger: {
                  trigger: contentRef1.current,
                  start: "top 20%",
                  end: "top top",
                  pinSpacing: false,
                  toggleActions: "restart resume none reverse",
                  scrub: true
                },
                opacity: 0,
                duration: 1
              });
            }
          },
          opacity: 0,
          duration: 0.3
        });
        gsap/* gsap.from */.p8.from(contentRef2.current, {
          scrollTrigger: {
            trigger: contentRef2.current,
            start: "top 80%",
            end: "center 60%",
            pinSpacing: false,
            toggleActions: "restart resume none reverse",
            scrub: true,
            onLeave: function onLeave() {
              gsap/* gsap.to */.p8.to(contentRef2.current, {
                scrollTrigger: {
                  trigger: contentRef2.current,
                  start: "top 20%",
                  end: "top top",
                  pinSpacing: false,
                  toggleActions: "restart resume none reverse",
                  scrub: true
                },
                opacity: 0,
                duration: 1
              });
            }
          },
          opacity: 0,
          duration: 0.3
        });
        gsap/* gsap.from */.p8.from(contentRef3.current, {
          scrollTrigger: {
            trigger: contentRef3.current,
            start: "top 80%",
            end: "center 60%",
            pinSpacing: false,
            toggleActions: "restart resume none reverse",
            scrub: true
          },
          opacity: 0,
          duration: 0.3
        });
      },
      "(max-width: 767px)": function maxWidth767px() {
        gsap/* gsap.from */.p8.from(contentRef1.current, {
          scrollTrigger: {
            trigger: contentRef1.current,
            start: "top bottom",
            end: "center 60%",
            pinSpacing: false,
            toggleActions: "restart resume none reverse",
            scrub: true,
            onLeave: function onLeave() {
              gsap/* gsap.to */.p8.to(contentRef1.current, {
                opacity: 0,
                duration: 1
              });
            }
          },
          opacity: 0,
          duration: 0.3
        });
        gsap/* gsap.from */.p8.from(contentRef2.current, {
          scrollTrigger: {
            trigger: contentRef2.current,
            start: "top 80%",
            end: "center 60%",
            pinSpacing: false,
            toggleActions: "restart resume none reverse",
            scrub: true,
            onLeave: function onLeave() {
              gsap/* gsap.to */.p8.to(contentRef2.current, {
                opacity: 0,
                duration: 1
              });
            }
          },
          opacity: 0,
          duration: 0.3
        });
        gsap/* gsap.from */.p8.from(contentRef3.current, {
          scrollTrigger: {
            trigger: contentRef3.current,
            start: "top 80%",
            end: "center 60%",
            pinSpacing: false,
            toggleActions: "restart resume none reverse",
            scrub: true
          },
          opacity: 0,
          duration: 0.3
        });
      }
    });
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AboutPageWrapper, {
    id: "aboutUsWrapper",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeroBanner_HeroBanner, {
      title: heroBanner.title,
      src: heroBanner.src,
      alt: heroBanner.alt,
      heroVideo: heroBanner.heroVideo
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HeroContent_HeroContent, {
      content: heroContent[0],
      contentRef: contentRef1
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HeroContent_HeroContent, {
      content: heroContent[1],
      contentRef: contentRef2
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HeroContent_HeroContent, {
      content: heroContent[2],
      contentRef: contentRef3
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OurJourney_OurJourney, {
      heading: ourJourney.heading,
      subHeading: ourJourney.subHeading,
      arrowSrc: ourJourney.arrowSrc,
      arrowAlt: ourJourney.arrowAlt,
      journeyData: ourJourney.journeyData,
      pinIconSrc: ourJourney.pinIconSrc
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spotlight_Spotlight, {
      title: spotLight.title,
      subTitle: spotLight.subTitle,
      spotLightNews: spotLight.spotLightNews,
      footerArrow: spotLight.footerArrow
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OurTeam_OurTeam, {
      title: ourTeam.title,
      subTitle: ourTeam.subTitle,
      joinUsInfo: ourTeam.joinUs,
      opportunities: ourTeam.opportunities
    })]
  });
};

/* harmony default export */ var ui_container_AboutUs = (AboutUs);

/***/ })

}]);